<template>
  <b-col cols="11" offset-lg="3" lg="5">
    <b-link
      v-for="(item, idx) in availableCoupons"
      :key="`coupon_${idx}`"
      :href="item.href || '#'"
      :target="item.target || '_self'"
      class="d-block mb-2">
      <b-img ref="couponAnniversary" :src="item.img" fluid />
    </b-link>
  </b-col>
</template>

<script>
  export default {
    props: {
      anniversaryIdentity: {
        type:     String,
        required: true,
      },
    },
    data () {
      const isProdServer = process.env.prod

      return {
        coupons: [
          {
            // FIXME: 未來新增活動時，可刪除過期活動的圖片和程式
            // 指定方案首月85折 (活動走期：2022/3/28 ~ 2022/4/29)
            start:     isProdServer ? '2022-03-28T00:00:00+0800' : '2022-03-21T00:00:00+0800',
            end:       isProdServer ? '2022-04-29T23:59:59+0800' : '2022-03-24T23:59:59+0800',
            img:       'images/u/uid/service/product/202204_channel_discount.png',
            // 達人的 account identity
            whiteList: [
              '017d7496f77b00276ef2000000000000', // dev test - u671
              '017c267090ae0000052f000000000000', // stage test - [微大力]
              '01648d32b9790000065c000000000000', // prod begin - [阿斯匹靈]
              '016490d7f88900000689000000000000', // [華倫老師]
              '016492bf528f00000689000000000000', // [基金V怪客]
              '01717148edaf000005e4000000000000', // prod end - [傑股眼]
            ],
            href:   'https://lihi1.com/l2pwH',
            target: '_blank',
          },
        ],
      }
    },
    computed: {
      availableCoupons () {
        return this.coupons.filter(
          coupon => (
            (!coupon.start || this.$moment().valueOf() >= this.$moment(coupon.start).valueOf())
            && (!coupon.end || this.$moment().valueOf() <= this.$moment(coupon.end).valueOf())
            && (coupon.whiteList.indexOf(this.anniversaryIdentity) !== -1)
          ),
        )
      },
    },
  }
</script>
